export const AppConstants = {
  SSO_AUTH_TOKEN_DETAIL: "SSO_AUTH_TOKEN_DETAIL",
  appUrls: {
    MASTERDATA: "/masterdata",
    USERS: "/masterdata/users",
    RETAILERS: "/masterdata/retailers",
    TEAMS: "/masterdata/teams",
    TREATMENTS: "/masterdata/treatments",
    CROPS: "/masterdata/crops",
    PRODUCTS: "/masterdata/products",
    COMBINED_PRODUCTS: "masterdata/combinedproducts",
    LOCATIONS: "/masterdata/locations",
    SEASON: "/masterdata/seasons",
    TREATMENT_PRODUCTS: "/masterdata/treatmentproducts",
    ONFARM_TREATMENT_PRODUCTS: "/masterdata/onfarmtreatmentproducts",
    INVENTORY: "/main/inventory",
    DASHBOARD: "/main/dashboard",
    TRIAL_EXPERIMENTS: "/main/trial-experiments",
    TRIAL_DETAILS: "/main/trial-experiments/trial-details",
    ONFARM_REPORTS: "/main/onfarm-reports",
    REGIONS: "/main/regions",
    MASTERCATALOG: "/main/mastercatalog",
    REPORT: "/main/report",
    H2H_TYPE: "/main/report/h2htype",
    H2H_REPORT: "/main/report/h2hreport",
    ADHOC: "/main/report/adhoc",
    DATA_COLLECTIONS: "/main/collectionlocation",
    TRIALS: "/main/trial/trials",
    PROTOCOLS: "/main/trial/protocol",
    EXPERIMENT_TRIAL_LOCATIONS: "main/trial/triallocations",
    EXPERIMENT_TRIAL_LOCATIONS_FIELDMAP: "/main/trial/triallocations",
    EXPERIMENT_TRIAL_LOCATIONS_CREATE_LOCATION:
      "/main/trial/triallocations/createlocation",
    EXPERIMENT_MAPPING_SHEET: "/main/trial/worksheets",
    EXPERIMENT_MAPPING_SHEET_TEAM: "/main/trial/worksheets",
    EXPERIMENT_TRIAL_LOCATIONS_BOOK: "main/trial/triallocations/locationbook",
    DEMOS: "/main/trial/demos",
    DEMO_INVENTORY: "/main/demo/demoInventory",
    DEMO_TRIALS: "/main/demo/demoTrial",
    DATA_COLLECTION_FIELDBOOK:
      "main/trial/triallocation/datacollection/fieldbook",
    DATA_COLLECTION_REPBOOK: "main/trial/triallocation/datacollection/repbook",
    DATA_COLLECTION_TREATMENT:
      "main/trial/triallocation/datacollection/treatment",
    DATA_COLLECTION_LABBOOKS:
      "main/trial/triallocation/datacollection/labbooks",
    DATA_COLLECTION_OBSERVATIONS:
      "main/trial/triallocation/datacollection/observations",
    DATA_COLLECTION_APPLICATIONS:
      "main/trial/triallocation/datacollection/applications",
    EXPERIMENT_TRIAL_LOCATION: "main/experiments/triallocation",
    TRIAL_PROTOCOL: "/main/trial/protocol",
    PRINTING: "main/more/printing",
    EXPORT: "/main/more/export",
    SEED_CALCULATION: "/main/more/seedcalculation",
    MASTER_CATALOG: "/main/mastercatalog",
    ENTRY_MEANS_REPORT: "/main/report/entrymeansreport",
    SELECT_APPLICATION: "/select",
    FIELD_BOOK_CATALOG: "/main/mastercatalog?type=fieldbookcatalog",
    REP_BOOK_CATALOG: "/main/mastercatalog?type=repbookcatalog",
    LAB_BOOK_CATALOG: "/main/mastercatalog?type=labbookcatalog",
    APPLICATIONS_CATALOG: "/main/mastercatalog?type=applicationscatalog",
    OBSERVATIONS_CATALOG: "/main/mastercatalog?type=observationscatalog",
    LOCATION_CATALOG: "/main/mastercatalog/locationcatalog",
    TASK_PLANNER: "/main/dashboard/task-planner",
    TRIAL_BOOK: "/main/dashboard/trial-book",
    FIELD_REP: "/main/dashboard/field-rep",
    TRIALEXPERIMENTS_CREATE: "/main/trial-experiments/create",
    TRIALEXPERIMENTS: "/main/trial-experiments",
    SINGLE_TRIAL_REPORT: "/main/onfarm-reports/singletrialreport",
    HEAD_TO_HEAD_REPORT: "/main/onfarm-reports/headtoheadreport",
    ONE_TO_MANY_REPORT: "/main/onfarm-reports/onetomanyreport",
  },
  pages: [
    { title: "Master Data", path: "/masterdata" },
    { title: "Users", path: "/masterdata/users" },
    { title: "Retailers", path: "/masterdata/retailers" },
    { title: "Crops", path: "/masterdata/crops" },
    { title: "Teams", path: "/masterdata/teams" },
    { title: "Treatments", path: "/masterdata/treatments" },
    { title: "Products", path: "/masterdata/products" },
    { title: "Products", path: "/masterdata/combinedproducts/"},
    { title: "Products", path: "/masterdata/combinedproducts/products"},
    { title: "Products", path: "/masterdata/combinedproducts/pending-products"},
    { title: "Locations", path: "/masterdata/locations" },
    { title: "Seasons", path: "/masterdata/seasons" },
    { title: "Treatment Products", path: "/masterdata/treatmentproducts" },
    { title: "Treatment Products", path: "/masterdata/onfarmtreatmentproducts" },
    { title: "Treatment Products", path: "/masterdata/onfarmtreatmentproducts/treatmentproducts" },
    { title: "Treatment Products", path: "/masterdata/onfarmtreatmentproducts/pendingtreatmentproducts" },
    { title: "Trial Experiments", path: "/main/trial-experiments" },
    { title: "Reports", path: "/main/onfarm-reports" },
    { title: "Regions", path: "/main/regions" },
    { title: "Task Planner", path: "/main/dashboard/task-planner" },
    { title: "Trial Book", path: "/main/dashboard/trial-book" },
    { title: "Field Rep", path: "/main/dashboard/field-rep" },

  ],
  PAGE_TITLES: {
    TRIAL_LOCATIONS: "Trial Locations",
    EXPERIMENTS: "Experiments",
    FIELD_MAP: "Field Map",
    DATA_COLLECTION: "Data Collection",
    DEMO: "Demo",
    DEMOS: "Demos",
    DEMO_TRIAL: "Demo Trials",
    DEMO_INVENTORY: "Demo Inventory",
    TRIALS: "Trials",
    TRIAL: "Trial",
    WORKSHEET: "Worksheet",
    PROTOCOLS: "Protocols",
    PRINTING: "Printing",
    COMBINED_PRODUCTS: "Products",
    EXPORT: "Export",
    SEED_CALCULATION: "Seed Calculation",
    MASTER_CATALOG: "Master Catalog",
    ENTRY_MEANS_REPORT: "Entry Means Report",
    REPORT: "Report",
    TRIAL_EXPERIMENTS: "Trial Experiments",
    ONFARM_REPORTS: "Reports",
    REGIONS: "Regions",
    TRIAL_DETAILS: "Trial Details",
    ON_FARM_REPORT: "Report",
    FIELD_BOOK_CATALOG: "Field Book",
    REP_BOOK_CATALOG: "Rep Book",
    LAB_BOOK_CATALOG: "Lab Book",
    APPLICATIONS_CATALOG: "Applications",
    OBSERVATIONS_CATALOG: "Observations",
    LOCATION_CATALOG: "Locations",
    LOCATION_APPLICATIONS_CATALOG: "Location Applications Catalog",
    LOCATION_META_DATA_CATALOG: "Location MetaData Catalog",
    DASHBOARD: "Dashboard",
    TASK_PLANNER: "Task Planner",
    PROGRESS_TRACKER: "Progress Tracker",
    TRIAL_BOOK: "Trial Book",
    FIELD_REP: "Field Rep",
  },
  COMMON_TEXT: {
    SEARCH_HINT_TEXT: "Press enter to search",
    DELETE_CONFIRM_TITLE: "Delete Confirmation",
    UPDATE_CORFIRM_TITLE: "Enable On-Farm Update Confirmation",
    UPDATE_ENABLE_ONFARM_CONFIRM_TITLE: "Enable On-Farm Update Confirmation",
    APPROVE_CORFIRM_TITLE: "Approve Product Confirmation",
    LOGOUT_CONFIRM_TITLE: "Logout Confirmation",
    LOGOUT_CONFIRM_DESCRIPTION: "Are you sure you want to logout?",
    DELETE_CONFIRM_DESCRIPTION: "Are you sure you want to delete?",
    UPDATE_CONFIRM_DESCRIPTION: "Are you sure you want to update these products?",
    APPROVE_CONFIRM_DESCRIPTION: "Are you sure you want to approve this product?",
    SUBMIT_TRIAL_CONFIRM_TITLE: "Submit Trial Confirmation",
    SUBMIT_TRIAL_CONFIRM_DESCRIPTION: "Are you sure you want to submit the trial. You will not be able to modify the Trial Details after this operation.",
    CHANGE_TRIAL_STATUS_CONFIRM_TITLE: "Change Trial Status Confirmation",
    CHANGE_TRIAL_STATUS_CONFIRM_DESCRIPTION: "Are you sure you want to change the status to",
    SAVE_CONFIRM_DESCRIPTION: "Are you sure you want to save the Trial details?",
    MANDATORY_FIELDS_MISSING: "Mandatory fields are missing. Please update the required fields before proceeding. Click Yes to continue.",
    MANDATORY_FIELDS_MISSING_TITLE: "Mandatory Fields Missing",
    CONFIRM_DIALOG_OK: "OK",
    CONFIRM_DIALOG_YES: "Yes",
    CONFIRM_DIALOG_NO: "No",
    CONFIRM_DIALOG_SAVE: "Save",
    CONFIRM_DIALOG_DISCARD: "Discard",
    SHOW_ALL: "Show All",
    SEARCH_BY_USER_NAME: "Search By Name",
    SEARCH_BY_PRODUCT_NAME: "Search by Treatment Product",
    DISCARD_CONFIRM_DESCRIPTION:
      "All changes will be lost if you discard. Do you want to continue?",
    RESET_CONFIRM_DESCRIPTION:
      "Management related data will be lost. Do you want to continue ?",
    DISCARD_CONFIRM_TITLE: "Discard Confirmation",
    APPROVE_TREATMENT_PRODUCT_TITLE: "Approve Treatment Product Confirmation",
    APPROVE_TREATMENT_PRODUCT_DESCRIPTION: "Are you sure you want to approve this treatment product?",
    MISSING_MANDATORY_FIELDS_TITLE: "Missing Mandatory Fields",
    MISSING_MANDATORY_FIELDS_DESCRIPTION: "Mandatory fields are missing. Do you want to update?",
    SAVE_CONTINUE_CONFIRM: "Do you Want to Save or Continue?",
    SAVE: "Save",
    CONTINUE: "Continue",
    CANCEL: "Cancel",
    PROCEED: "PROCEED",
    ERROR_TITLE: "Error !",
    WARNING_TITLE: "Warning !",
    SAVE_CONFIRMATION: "Save Confirmation",
    SAMPLE_MESSAGE: "This sample does not belong to",
    SWITCH_DASHBOARD_CONFIRM_TITLE: "Switch Dashboard Confirmation",
    ALERT_TITLE: "Alert !",
    PRINT_CONFIRM_TITLE: "Print Confirmation",
    PRINT_GREEN_PACKETS_CONFIRMATION:"Are you sure you want to print green packets?",
    ACCESS_DENIED_MESSAGE: "User does not exist in TrialWyze application.",
    WINFIELD_UNITED_PROVING_GROUND_RESULTS: "WinField United Proving Ground Results",
    WINFIELD_UNITED_MARKET_SUPPORT_RESULTS: "WinField United Market Support Results",
    SINGLE_TRIAL_REPORT: "Single Trial Report",
    MANDATORY_PRODUCT_TREATMENT: "At least one Hybrid/Variety is required in Trial Mapping."
  },
  APP_DEFAULT_FILTER: {
    SELECTED_CROP: "CORN",
  },

  APPLICATION_NAMES: {
    APD: "Answerplot",
    ONFARM: "On-farm",
  },

  APPLICATION_CODES: {
    APD: "apd",
    ANSWERPLOT: "answerplot",
    ONFARM: "onfarm",
  },

  // Titles passed to helperFunctions.downloadFile for notes/pictures bulk exports.
  FILE_NAMES: {
    LOCATION_CATALOG_NOTES: "Notes_LocationCatalog",
    LOCATION_CATALOG_PICTURES: "Images_LocationCatalog",
    AGRONOMIC_DATA_NOTES: "Notes_OnFarm_Agronomic",
    AGRONOMIC_DATA_PICTURES: "Images_OnFarm_Agronomic",
    HARVEST_DATA_NOTES: "Notes_OnFarm_Harvest",
    HARVEST_DATA_PICTURES: "Images_OnFarm_Harvest",
    OBSERVATION_REP_LEVEL_NOTES: "Notes_ObservationBook",
    OBSERVATION_REP_LEVEL_PICTURES: "Images_ObservationBook",
    OBSERVATION_ENTRY_LEVEL_NOTES: "Notes_RatingBook",
    OBSERVATION_ENTRY_LEVEL_PICTURES: "Images_RatingBook"
  },

  SYSTEM_ADMIN_ID: 1,

  CUSTOM_EVENTS: {
    LOG_OUT_USER: "logoutUser",
  },
  DEFAULT_PAGE_SIZE: 50,
  DATA_COLLECTION_DEFAULT_PAGE_SIZE: 200,
  ATTRIBUTES_DEFAULT_PAGE_SIZE: 500,
  DROPDOWN_DEFAULT_PAGE_SIZE: 1000, 
  RECURSIVE_DATA_DEFAULT_PAGE_SIZE: 500, // To Be Checked if recurrsive apis can accept 1000 pagesize, if yes we will merge dropdown and recurrsive.
  DATA_COLLECTION_MAX_CHAR_LENGTH: 250,
  utmZonesList: [
    {
      zoneNumber: "Web Mercator",
      name: "Web Mercator",
      wkid: 102100,
    },
    {
      zoneNumber: 10,
      name: "UTM 10N",
      wkid: 26910,
    },
    {
      zoneNumber: 11,
      name: "UTM 11N",
      wkid: 26911,
    },
    {
      zoneNumber: 12,
      name: "UTM 12N",
      wkid: 26912,
    },
    {
      zoneNumber: 13,
      name: "UTM 13N",
      wkid: 26913,
    },
    {
      zoneNumber: 14,
      name: "UTM 14N",
      wkid: 26914,
    },
    {
      zoneNumber: 15,
      name: "UTM 15N",
      wkid: 26915,
    },
    {
      zoneNumber: 16,
      name: "UTM 16N",
      wkid: 26916,
    },
    {
      zoneNumber: 17,
      name: "UTM 17N",
      wkid: 26917,
    },
    {
      zoneNumber: 18,
      name: "UTM 18N",
      wkid: 26918,
    },
    {
      zoneNumber: 19,
      name: "UTM 19N",
      wkid: 26919,
    },
  ],
  placementOrderList: {
    LeftToRight: "LeftToRight",
    Serpentine: "Serpentine",
  },
  TIME_FORMATS: {
    DISPLAY_12HR: "h:mm A", // 12-hour display format (e.g., 2:15 PM)
    DISPLAY_24HR: "HH:mm:ss", // 24-hour display format (e.g., 14:15:00)
  },
  KIOSK: "kiosk", // value for kiosk mode
  APP_MODE: "APP_MODE", // key for localStorage for app mode kiosk or not
  USER_ROLE: "USER_ROLE", // key for localStorage for user role
  SUPPORT_EMAIL: "trialwyzesupport@landolakes.com",
};
